// extracted by mini-css-extract-plugin
export default {"heading":"ot-z","corrected":"pt-z","redirectVerbiageContainer":"qt-z","redirectVerbiageText":"rt-z"};